import { UcoastEl } from '@/scripts/core/UcoastEl'
import { qsOptional } from '@/scripts/core/global'
import { ScrollArrows } from '@/scripts/global/ScrollArrows'

const DESKTOP_MQ = '(min-width: 990px)'

export class FeaturedProductsCarousel extends UcoastEl {
	static htmlSelector = 'featured-products-carousel'
	scrollArrows?: ScrollArrows
	scrollContainer?: HTMLElement
	desktopMq?: MediaQueryList
	boundOnBreakpoint: () => void

	constructor() {
		super()
		this.boundOnBreakpoint = this.onBreakpoint.bind(this)
		const scrollContainer = qsOptional('[data-scroll-track]', this)
		const track = qsOptional('.featured-products__grid', this)
		if (!scrollContainer || !track) return
		this.scrollContainer = scrollContainer
		this.scrollArrows = new ScrollArrows({
			root: this,
			scrollContainer,
			track,
			prevButton: qsOptional('[data-prev]', this),
			nextButton: qsOptional('[data-next]', this),
		})
		this.desktopMq = window.matchMedia(DESKTOP_MQ)
		this.desktopMq.addEventListener('change', this.boundOnBreakpoint)
		this.onBreakpoint()
	}

	onBreakpoint() {
		if (this.desktopMq?.matches) {
			this.scrollContainer?.scrollTo({ left: 0 })
		}
		this.scrollArrows?.updateOverflowState()
	}

	override disconnectedCallback() {
		super.disconnectedCallback()
		this.desktopMq?.removeEventListener('change', this.boundOnBreakpoint)
		this.scrollArrows?.destroy()
	}
}
